import { FramedAvatar, rankTheme } from "./RankFrame";

// Pall med topp 3: 2:an till vänster, 1:an i mitten (högst), 3:an till höger.
export default function Podium({ standings = [] }) {
  const top = standings.slice(0, 3);
  if (top.length === 0) return null;
  const byRank = Object.fromEntries(top.map((r) => [r.rank, r]));
  const order = [2, 1, 3].filter((k) => byRank[k]);
  const heights = { 1: 108, 2: 80, 3: 62 };
  return (
    <div className="flex items-end justify-center gap-2 pt-8 pb-1" data-testid="podium">
      {order.map((rank) => {
        const r = byRank[rank];
        const th = rankTheme(rank);
        return (
          <div key={rank} className="flex flex-col items-center w-[31%] min-w-0" data-testid={`podium-${rank}`}>
            <FramedAvatar icon={r.icon} name={r.name} rank={rank} size={rank === 1 ? 64 : 50} />
            <div className="mt-3 text-sm font-bold text-slate-100 truncate max-w-full text-center">{r.name}</div>
            <div className={`text-xs font-mono font-bold ${th.text}`}>{r.rating} Elo</div>
            <div className={`mt-2 w-full rounded-t-xl bg-gradient-to-b ${th.block} flex flex-col items-center justify-start pt-2 border-t border-white/20`} style={{ height: heights[rank] }}>
              <span className="text-2xl leading-none">{th.medal}</span>
              <span className="text-slate-950/80 text-[11px] font-black mt-1">{r.wins} vinster</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
